const DOT_GAP = 5
export const DOT_WIDTH = 8
export const DOT_SECTION_SIZE = DOT_WIDTH + DOT_GAP
export const DRAG_CANCEL_DISTANCE = 90
